export default [

     {
          path: '/certificate-templates',
          name: 'CertificateTemplates',
          component: () => import("@/views/Page/CertificateTemplates/CertificateTemplates.vue"),
           meta: {
               title: 'CertificateTemplates',
          },
     }
];